import React from "react";

const PerformanceRing = ({ percent = 0, color = "#22c55e" }) => {
  const value = Math.max(0, Math.min(100, Number(percent) || 0));
  const bg = `conic-gradient(${color} ${value * 3.6}deg, #e5e7eb 0deg)`;

  return (
    <div className="pd-ring-wrap">
      <div className="pd-ring" style={{ background: bg }}>
        <div className="pd-ring-inner" style={{ color }}>
          {value.toFixed(2)}%
        </div>
      </div>
      <div className="pd-ring-label">Performance</div>
    </div>
  );
};

export default PerformanceRing;
